import {
  OfficeFluidContainerJsCdnDogfood,
  OfficeFluidContainerJsCdnProd,
  OfficeFluidContainerPackageName,
  OneNoteMeetingPackageName
} from './Constants';

/** The list of CDNs that we trust as M365 container developers
 * If you add a new code origin to the list, make sure to update the getContainerTypeFromPackageName method with the appropriate container package name
 */
export const defaultAllowedCodeOrigins = [
  'https://cdn.dev.fluidpreview.office.net', // Future Dev CDN to be used by Office Fluid Container
  'https://cdn.fluidpreview.office.net', // Future Prod CDN to be used by Office Fluid Container
  OfficeFluidContainerJsCdnDogfood,
  OfficeFluidContainerJsCdnProd,
  'https://amsglob0cdnstream13.azureedge.net', // Microsoft Stream Prod
  'https://blobs.officehome.msocdn.com', // Office.com Prod
  'https://officehome.cdn.office.net', // Office.com 1CDN
  'https://int.whiteboard.microsoft.com', // Whiteboard Dogfood
  'https://whiteboard.microsoft.com' // Whiteboard Prod
];

/**
 * Method that returns a Container Type based on the packageName passed
 */
export const getContainerTypeForLogging = (packageName: string) => {
  switch (packageName) {
    case OneNoteMeetingPackageName:
    case OfficeFluidContainerPackageName:
    case '@msstream/experiences-fluid-embed':
    case '@office-start/space-container':
    case '@ms/whiteboard-container':
      return packageName;
    default:
      return 'Unknown';
  }
};
